module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/performance-yellow.a861a0b2.svg";